import { render, staticRenderFns } from "./yhubPieChart1.vue?vue&type=template&id=385b4496"
import script from "./yhubPieChart1.vue?vue&type=script&lang=js"
export * from "./yhubPieChart1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports